import React from 'react'
import { Typography } from '@mui/material'
import { EventsOfTask } from 'pages/Tasks/types'
import TimelineBadge from 'redesign/components/molecules/timeline-badge'
import { TIMELINE_BADGE_VARIANTS } from 'redesign/components/molecules/timeline-badge/constants'
import type { TimelineBadgeProps } from 'redesign/components/molecules/timeline-badge/types'
import type { MessageDrawerProps } from 'redesign/services/timeline-action-button/types'
import type { DeleteAbsenceRequestProps } from '../../types'

const getDeleteRequest = ({
  setMessageDrawerProps,
  t,
  sendEvent,
  onDeletionRequestCompleted,
}: DeleteAbsenceRequestProps) => {
  const rejectRequestBadgeProps: TimelineBadgeProps = {
    variant: TIMELINE_BADGE_VARIANTS.error,
    text: 'timeline.badge.deletionRequest',
    tooltipText: 'absenceRequest.deletionRequest.tooltipFrontliner',
    testId: 'task-status_deletion-request',
  }

  const rejectRequestDrawerProps: Partial<MessageDrawerProps> = {
    headerLabel: <TimelineBadge {...rejectRequestBadgeProps} />,
    placeholder: t('absenceRequest.requestDeletion.comment.placeholder'),
    commentText: t('absenceRequest.requestDeletion.body'),
  }

  return setMessageDrawerProps({
    onClick: (comment: string) =>
      sendEvent(EventsOfTask.absenceRequestRequestDeletion, comment, onDeletionRequestCompleted),
    headerLabel: <Typography variant="subtitle1">{t('label.comment')}</Typography>,
    isRequired: true,
    commentFieldLabel: t('inputLabel.comment'),
    ...rejectRequestDrawerProps,
  })
}

export default getDeleteRequest
